import { makeStyles } from '@material-ui/core/styles';
import ChevronRight from '@material-ui/icons/ChevronRight';
import baseCTAStyles from '@/features/CTA/CTA.styles';
import { createElement } from 'react';
import { TextColors } from '@/utils/constants';
import { encodeSvg } from '@/utils/helpers';

const darkTheme = {
  root: {
    color: TextColors.light,

    '& $heading': {
      color: TextColors.light,
    },

    '& $rtc': {
      '& a[href]': {
        '&:after': {
          backgroundImage: `url(${encodeSvg(
            createElement(ChevronRight, {
              xmlns: 'http://www.w3.org/2000/svg',
              fill: TextColors.light,
            }),
          )})`,

          '&:hover': {
            color: TextColors.light,
          },
        },
      },

      '& a[href], & a[href]:not(:hover)': {
        color: TextColors.light,
      },
    },
  },
};

const lightTheme = {
  root: {
    color: TextColors.dark,

    '& $heading': {
      color: TextColors.dark,
    },

    '& $rtc': {
      '& a[href]': {
        '&:after': {
          backgroundImage: `url(${encodeSvg(
            createElement(ChevronRight, {
              xmlns: 'http://www.w3.org/2000/svg',
              fill: TextColors.dark,
            }),
          )})`,

          '&:hover': {
            color: TextColors.dark,
          },
        },
      },

      '& a[href], & a[href]:not(:hover)': {
        color: TextColors.dark,
      },
    },
  },
};

const useStyles = makeStyles(
  () => ({
    ...baseCTAStyles,
    root: {
      '&.dark-theme': darkTheme.root,
      '&.light-theme': lightTheme.root,
    },
  }),
  { name: 'GenTpdCTA' },
);

export default useStyles;
